/* eslint-disable import/prefer-default-export */

export enum SettingsMenuItem {
  GENERAL = "general",
  COURTS = "courts",
  PRICES = "prices",
  SERVICE_HOURS = "service_hours",
  AUTOMATIC_BOOKINGS = "automatic_bookings",
}
